import { render, staticRenderFns } from "./AtomImageTitle.vue?vue&type=template&id=521b6464&scoped=true&"
import script from "./AtomImageTitle.vue?vue&type=script&lang=js&"
export * from "./AtomImageTitle.vue?vue&type=script&lang=js&"
import style0 from "./AtomImageTitle.vue?vue&type=style&index=0&id=521b6464&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521b6464",
  null
  
)

export default component.exports